'use strict';

define('features/slp/dealer',[
  'jquery',
  'txt!./dealer.hbs',
  'txt!./dealer.results.hbs',
  'lib/services/batws',
  'lib/paginator',
  'lib/transforms/dealer.tmpl.common',
  'lib/util/tda.config',
  'cookies',
  'lib/util/zip',
  'lib/analytics/pageload',
  'lib/analytics/context.add',
  'lib/analytics/blocks/index',
  'lib/page-cache',

  // side effect includes
  'Handlebars'
], function (
  $,
  txtTemplate,
  txtDealerSearchResults,
  batws,
  Paginator,
  xformDealersCommon,
  tdaConfig,
  cookies,
  zip,
  anPageLoad,
  anAddContext,
  blocks,
  PageCache
) {
  var __tmplDealers = Handlebars.compile(txtTemplate);
  var __tmplDealerResults = Handlebars.compile(txtDealerSearchResults);
  var __isWWW = tdaConfig.tda.code === 'WWW';
  var __firstSearch = true;

  var __identityFilter = function () {
    return true;
  };

  var __pmaFilter = function (dealer) {
    return dealer.isPma;
  };

  function __dealerQuery(opts) {
    var paginatorOpts = {
      query: {},
      dataField: 'dealerLocator',
      countField: 'dealerCount',
      xform: xformDealersCommon,
      pageSize: 5
    };
    return Object.assign(paginatorOpts, opts);
  }

  // new instance of SelectDealer created via form.js
  var SelectDealer = function (el, config) {
    this.$el = $(el);
    this.config = config;
  };

  // load invoked via form.js
  Object.assign(SelectDealer.prototype, {
    load: function () {
      var self = this;
      var ctx = {
        formLength: this.config.formLength,
        i18n: this.config.i18n
      };
      console.log('CTX for Select Dealer: ', ctx); // eslint-disable-line no-console
      this.$el.html(__tmplDealers(ctx));
      self.loadEvents();
      return PageCache.await('dealers.loaded');
    },

    setMode: function (mode) {
      this.mode = mode;
      if (mode === 'pma') {
        this.filter = __pmaFilter;
      } else {
        this.filter = __identityFilter;
      }
    },

    beginSearch: function (calcZip) {
      var self = this;
      self.showLoader();
      self.searchTerm = calcZip;
      if (!self.mode) {
        self.setMode('pma');
      }
      var query = __dealerQuery({
        query: {
          zipcode: calcZip
        }
      });
      self.paginator = new Paginator(batws.geo().search, query);
      self.paginator.next()
        .then(function pageNext(res) {
          self.showResults(res);
          PageCache.set('dealers.loaded');
        })
        .catch(function (err) { console.log('Err: ', err); }); // eslint-disable-line no-console
    },

    showResults: function (res) {
      var self = this;
      self.hideLoader();
      var dealerData = Object.assign({}, res, {
        records: res.records.filter(self.filter),
      });
      $('#dealer-results', self.$el)
        .html(__tmplDealerResults({
          i18n: self.config.i18n,
          dealerResults: dealerData,
          detailRoot: '/' + tdaConfig.site.context_url,
          pma: self.mode === 'pma',
        }));

      self.dealerResultEvents();
      self.analyticsDealerSearch(dealerData);
    },

    loadEvents: function () {
      var self = this;
      var $zipField = $('.js-zip', self.$el);

      function doSearch() {
        self.setMode('pma');
        self.beginSearch($zipField.val());
      }

      if (__isWWW || cookies.getItem('isConfirmedZip') !== 'true') {
        $zipField.val('');
        PageCache.set('dealers.loaded');
        __firstSearch = false;
      } else {
        $zipField.val(zip.getCookiedDefaultFallback());
        doSearch();
      }

      $('.js-search', self.$el).on('click', function (e) {
        e.preventDefault();
        doSearch();
      });

      $(window).on('ZIP_CODE_CHANGED', function () {
        $zipField.val(zip.getCookiedDefaultFallback());
        doSearch();
      });
    },

    dealerResultEvents: function () {
      var self = this;
      $('.js-dealers-all', self.$el).on('click', function (e) {
        e.preventDefault();
        self.viewAll();
      });

      $('.js-page-next', self.$el).on('click', function (e) {
        e.preventDefault();
        self.nextPage();
      });

      $('.js-page-prev', self.$el).on('click', function (e) {
        e.preventDefault();
        self.prevPage();
      });

      $('input[name="dealerCode"]', self.$el).on('change', function (e) {
        self.analyticsSelectedDealer($(this).val());
      });
    },

    showLoader: function () {
      $('.loader', this.$el).show();
    },

    hideLoader: function () {
      $('.loader', this.$el).hide();
    },

    nextPage: function () {
      var self = this;
      if (self.paginator.hasNext()) {
        self.showLoader();
        self.paginator.next()
          .then(function (res) {
            self.showResults(res);
          })
          .catch(function (err) { console.log('Err: ', err); }); // eslint-disable-line no-console
      }
    },

    hasDealers: function () {
      return this.paginator && this.paginator.count > 0;
    },

    prevPage: function () {
      if (this.paginator.hasPrev()) {
        this.showResults(this.paginator.prev());
      }
    },

    viewAll: function () {
      this.setMode('all');
      this.showResults(this.paginator.pageData);
    },

    analyticsDealerSearch: function (dealerData) {
      var $componentScope = $('#' + this.config.formType);
      var dealerDl = {};

      if (dealerData) {
        if (dealerData.records.length) {
          dealerDl = dealerData.records[0].dataLayer;
        }
        anAddContext(
          $componentScope,
          blocks.dealerSearchBlock(this.searchTerm, 'zip', dealerData.records.length),
          blocks.dealerBlock(dealerDl)
        );
      }

      // We do not fire pageLoads on first search. Forms.js handled
      // that pageLoad. We did build context (above) though...
      // Subsequent dealer searches (!__firstSearch) do fire pageLoads though. Yaaay.
      if (!__firstSearch && !$.isEmptyObject(dealerDl)) {
        anPageLoad($componentScope, blocks.keyMetrics('km-dealer-search'));
      } else if (!__firstSearch) {
        anPageLoad($componentScope);
      }
      __firstSearch = false;
    },

    analyticsSelectedDealer: function (dealerCode) {
      var $componentScope = $('#' + this.config.formType);
      var dealer = this.paginator.pageData.records.find(function (item) {
        return item.dealerCode === dealerCode;
      });
      anAddContext($componentScope, blocks.dealerBlock(dealer.dataLayer));
    }
  });

  return SelectDealer;
});

